import { createAsyncThunk } from "@reduxjs/toolkit";

import api from "../../../utils/api";
import { RootState } from "../../rootReducer";
import axios from "axios";
import axiosInstance from "../../../utils/axiosConfig";

export const sendPeopleNotifications = createAsyncThunk(
  "massNotifications/sendPeopleNotifications",
  async (arg, { rejectWithValue, getState }) => {
    try {
      const channels = [];
      const state = getState() as RootState;
      const people = state.massNotification.selectedPeople;
      const email = state.massNotification.email;
      if (email) channels.push(1);
      const whatsapp = state.massNotification.whatsapp;
      if (whatsapp) channels.push(2);
      const idsPeople = people.map((people) => people.id);
      const { data } = await axiosInstance.post(`${api.baseURL}document/send-notifications-to-users`, {
        usersIds: idsPeople,
        channel: channels,
      });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
